/**
 * ¿Hay que canonicalizar el número principal del lead antes de enviarle algo?
 * Devuelve false (no-op) si el lead ya es "dueño" de ese phone_number:
 *  - su clave ya es el teléfono (contactId === `${companyId}#${mainPhone}`), o
 *  - su atributo phone_number guardado ya es el número, o
 *  - ya se canonicalizó en esta sesión (ownedPhone).
 */
export function shouldCanonicalizeMainPhone({
  contactId,
  storedPhone,
  ownedPhone,
  companyId,
  mainPhone,
}) {
  if (!mainPhone || !contactId) return false;
  if (ownedPhone && ownedPhone === mainPhone) return false;
  if (storedPhone && storedPhone === mainPhone) return false;
  if (companyId && contactId === `${companyId}#${mainPhone}`) return false;
  return true;
}
